"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _optionListModule = _interopRequireDefault(require("./option-list.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionList = function OptionList(_ref) {
  var style = _ref.style,
      options = _ref.options,
      selectedValue = _ref.value,
      onChange = _ref.onChange,
      optionRenderer = _ref.optionRenderer,
      optionClassName = _ref.optionClassName;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    style: style,
    className: _optionListModule["default"].list
  }, options.map(function (option) {
    var _cx;

    var value = option.value,
        label = option.label,
        optionDisabled = option.disabled;
    var isSelected = value === selectedValue;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: value,
      role: "option",
      "aria-selected": isSelected,
      onMouseDown: function onMouseDown() {
        if (!optionDisabled) {
          onChange(value);
        }
      }
    }, optionRenderer ? optionRenderer({
      option: _objectSpread(_objectSpread({}, option), {}, {
        selected: isSelected
      }),
      isSelectedOption: false
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_optionListModule["default"].listItem, (_cx = {}, _defineProperty(_cx, _optionListModule["default"].selected, isSelected), _defineProperty(_cx, _optionListModule["default"].disabled, optionDisabled), _defineProperty(_cx, optionClassName, Boolean(optionClassName)), _cx))
    }, label));
  }));
};

var noop = function noop() {};

OptionList.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })),
  style: _propTypes["default"].shape({}),
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  optionRenderer: _propTypes["default"].func,
  optionClassName: _propTypes["default"].string
};
OptionList.defaultProps = {
  style: {},
  value: '',
  options: [],
  onChange: noop,
  optionRenderer: undefined,
  optionClassName: ''
};
var _default = OptionList;
exports["default"] = _default;